import { DateTimeString } from 'models/common';

export enum ImportTaskStatus {
  NEW = 'NEW',
  IN_PROCESS = 'IN_PROCESS',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
}

export enum ImportTaskType {
  FIS_GIA = 'FIS_GIA',
  MANUAL_COMPETITIVE_GROUP_CHANGE = 'MANUAL_COMPETITIVE_GROUP_CHANGE',
}

export type ImportTaskPayloadResponse = {
  id: number;
  status: ImportTaskStatus;
  payload?: string;
};

export type ImportTaskResponse = {
  id: number;
  authorUserId: number;
  status: ImportTaskStatus;
  type: ImportTaskType;
  documentId?: number;
  createdAt: DateTimeString;
  updatedAt: DateTimeString;
  details: ImportTaskPayloadResponse[];
};
